import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  cardContainer: {
    backgroundColor: '#fff',
    padding: '0px 15px 15px 15px',
    width: '100%',
    border: 'none',
    boxShadow: 'none',
  },
  accordionResponseSectionTitleContainer: {
    marginTop: 0,
    marginBottom: 0,
  },
  accordionResponseSectionTitle: {
    color: theme.palette.primary.main,
    fontFamily: 'Poppins',
    fontSize: 20,
    fontStyle: 'normal',
    fontWeight: 700,
  },
  overrideDividerClassname: {
    color: '#CDCEDA',
    width: '100%',
    marginTop: 10,
    marginBottom: 10,
  },
  containerSection: {
    padding: 20,
    background: '#DBEAFE',
    borderRadius: 10,
  },
  separator: {
    width: '100%',
    position: 'relative',
    height: 2,
    background: 'white',
    margin: '15px 0px 25px',
  }
}));

export default useStyles;
